import { forwardRef, useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

import { AsyncTypeahead, Token } from "react-bootstrap-typeahead";

export const AutocompleteUsers = forwardRef((props, rootRef) => {
  const [multiSelections, setMultiSelections] = useState([]);
  const autoCompleteRef = useRef();
  const [options, setOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);

  console.log(rootRef);
  useEffect(() => {
    if (!rootRef?.current) return;
    console.log(rootRef.current);
    const el = rootRef.current.closest("[data-initial]");
    const val = el?.dataset.initial;
    if (val) setMultiSelections([{ id: val, label: val }]);
  }, [rootRef?.current]);
  const handleSearch = async (q) => {
    setLoading(true);
    const response = await fetch(
      `/escuela/contactos?${new URLSearchParams({ q })}`
    );
    const data = await response.json();
    setOptions(data);
    setLoading(false);
  };

  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    const form = autoCompleteRef.current.getInput().form;
    submit = document.querySelector(`[form=${form.id}]`);
    submit.disabled = multiSelections.length === 0;
  }, [multiSelections]);
  const handleKeyDown = (e) => {
    if (e.key === "," && options.length > 0) {
      e.preventDefault();

      setMultiSelections([...multiSelections, options[0]]);
    }
  };
  const filterBy = (option) => {
    return !multiSelections.find((o) => o.id === option.id);
  };

  const handleOnChange = (selected) => {
    console.log(selected);
    setMultiSelections(
      selected.map((it) => (it.customOption ? { ...it, id: it.label } : it))
    );
  };
  const handleListExpand = (option) => (ev) => {
    ev.stopPropagation();
    ev.preventDefault();

    setMultiSelections(
      multiSelections.reduce((acc, cur) => {
        if (cur.id === option.id) {
          acc = acc.concat(option.lista);
        } else {
          acc.push(cur);
        }
        return acc;
      }, [])
    );
  };
  useEffect(() => {
    handleSearch("");
  }, []);

  const handleContactClick = async (ev) => {
    ev.preventDefault();

    autoCompleteRef.current?.toggleMenu();
  };

  const handleClear = () => {
    autoCompleteRef.current.clear();
    setMultiSelections([]);
  };

  return (
    <>
      <Form.Label className="input-group-text mb-0 align-items-start col-1">
        Para:
      </Form.Label>
      <AsyncTypeahead
        id="destinatarios"
        // filterBy={filterBy}
        onKeyDown={handleKeyDown}
        isLoading={isLoading}
        labelKey="label"
        minLength={0}
        defaultSelected={options.slice(0, 1)}
        maxResults={30}
        allowNew
        newSelectionPrefix="Nuevo: "
        onSearch={handleSearch}
        options={options}
        ref={autoCompleteRef}
        placeholder="Contactos..."
        promptText="Buscar contactos"
        onChange={handleOnChange}
        selected={multiSelections}
        className=" col-11"
        renderToken={(option, { onRemove }, index) => {
          return (
            <Token key={index} onRemove={onRemove} option={option}>
              {option.label}{" "}
              {option.lista && (
                <span onClick={handleListExpand(option)}>
                  <i className="fas fa-expand" />
                </span>
              )}
            </Token>
          );
        }}
        multiple
      />

      <input
        type="hidden"
        name="recipients"
        value={Array.from(
          new Set(
            multiSelections
              .map((u) => u.lista || [u])
              .flat()
              .map((u) => u.id)
          )
        ).join(",")}
      />

      {!!multiSelections.length && (
        <a href="#" className="btn btn-outline-secondary" onClick={handleClear}>
          <i className="fa fa-times"></i>
        </a>
      )}
      <a
        href="#"
        className="btn btn-outline-secondary"
        onClick={handleContactClick}
      >
        <i className="fa fa-contact-book"></i>
      </a>
    </>
  );
});
